import React, { Component } from "react";

// Components
import PhoneField from "../../../utils/PhoneField";
import ErrorWrap from "../../../utils/error-success/ErrorWrap";

class EmergencyContactFieldset extends Component {
	constructor(props) {
		super(props);

		this.dataProps = [
			"emergency_contact_name",
			"emergency_contact_relationship",
			"emergency_contact_phone_home",
			"emergency_contact_phone_home_extension",
			"emergency_contact_phone_work",
			"emergency_contact_phone_work_extension",
			"emergency_contact_phone_mobile",
			"emergency_contact_phone_mobile_extension"
		];
		this.miscProps = ["errors", "inProcess"];
	}

	shouldComponentUpdate(nextProps) {
		// Check local props to see if any have changed
		const dataPropResults = this.dataProps.some(prop => {
			return this.props.data[prop] !== nextProps.data[prop];
		});
		const miscPropResults = this.miscProps.some(prop => {
			return this.props[prop] !== nextProps[prop];
		});

		// If any local props changed, we will rerender
		return dataPropResults || miscPropResults;
	}

	render() {
		const { data, errors, inProcess } = this.props;

		return (
			<div className="fieldset">
				<div className="title-label">Emergency Contact</div>

				<div className="fieldset-indent">
					<div className="floated-field-container">
						<div className="form-field half-field">
							<label>Emergency Contact Name:</label>

							{!!errors.emergency_contact_name && ( <ErrorWrap animate={1}>{errors.emergency_contact_name}</ErrorWrap> )}
							<input
								type="text"
								id="emergency_contact_name"
								value={data.emergency_contact_name}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>
						<div className="form-field half-field">
							<label>Relationship to Emergency Contact:</label>

							{!!errors.emergency_contact_relationship && (
								<ErrorWrap animate={1}>{errors.emergency_contact_relationship}</ErrorWrap>
							)}
							<input
								type="text"
								id="emergency_contact_relationship"
								value={data.emergency_contact_relationship}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>
					</div>

					<div className="floated-field-container">
						<PhoneField
							label={"Emergency Contact Phone (Home)"}
							phone_name="emergency_contact_phone_home"
							ext_name="emergency_contact_phone_home_extension"
							phone={data.emergency_contact_phone_home}
							extension={data.emergency_contact_phone_home_extension}
							errorPhone={errors.emergency_contact_phone_home}
							errorExtension={errors.emergency_contact_phone_home_extension}
							inProcess={inProcess}
							handleKeyPress={this.props.handleKeyPress}
							handleInputChange={this.props.handleInputChange}
						/>
						<PhoneField
							label={"Emergency Contact Phone (Work)"}
							phone_name="emergency_contact_phone_work"
							ext_name="emergency_contact_phone_work_extension"
							phone={data.emergency_contact_phone_work}
							extension={data.emergency_contact_phone_work_extension}
							errorPhone={errors.emergency_contact_phone_work}
							errorExtension={errors.emergency_contact_phone_work_extension}
							inProcess={inProcess}
							handleKeyPress={this.props.handleKeyPress}
							handleInputChange={this.props.handleInputChange}
						/>
					</div>

					<div className="floated-field-container">
						<PhoneField
							label={"Emergency Contact Phone (Mobile)"}
							phone_name="emergency_contact_phone_mobile"
							ext_name="emergency_contact_phone_mobile_extension"
							phone={data.emergency_contact_phone_mobile}
							extension={data.emergency_contact_phone_mobile_extension}
							errorPhone={errors.emergency_contact_phone_mobile}
							errorExtension={errors.emergency_contact_phone_mobile_extension}
							inProcess={inProcess}
							handleKeyPress={this.props.handleKeyPress}
							handleInputChange={this.props.handleInputChange}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default EmergencyContactFieldset;



// WEBPACK FOOTER //
// ./src/components/admin/reviewers/form-components/EmergencyContactFieldset.js